module.exports = __webpack_public_path__ + "ef28b57648e3b0ab8a54f2344cd7e820.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1month_show_thresholds_show_labels.png
// module id = 885
// module chunks = 7